import { Component } from '@theme/component';

export class SupportHubComponent extends Component {
  requiredRefs = ['input', 'form', 'results', 'list'];
  #entries = [];

  connectedCallback() {
    super.connectedCallback();
    this.#entries = this.#parseEntries();

    this.refs.input?.addEventListener('input', this.#onInput);
    this.refs.input?.addEventListener('focus', this.#onFocus);
    this.refs.input?.addEventListener('keydown', this.#onKeydown);
    this.refs.closeButton?.addEventListener('click', this.#onCloseClick);
    document.addEventListener('click', this.#onDocumentClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.input?.removeEventListener('input', this.#onInput);
    this.refs.input?.removeEventListener('focus', this.#onFocus);
    this.refs.input?.removeEventListener('keydown', this.#onKeydown);
    this.refs.closeButton?.removeEventListener('click', this.#onCloseClick);
    document.removeEventListener('click', this.#onDocumentClick);
  }

  #parseEntries() {
    try {
      const entries = JSON.parse(this.refs.payload?.textContent || '[]');
      return Array.isArray(entries) ? entries : [];
    } catch (error) {
      return [];
    }
  }

  #onInput = () => {
    this.#showResults(this.refs.input?.value || '');
  };

  #onFocus = () => {
    const query = this.refs.input?.value?.trim();
    if (query) this.#showResults(query);
  };

  #onKeydown = (event) => {
    if (event.key !== 'Escape') return;
    this.#hideResults();
  };

  #onCloseClick = () => {
    this.#hideResults();
    this.refs.input?.focus();
  };

  #onDocumentClick = (event) => {
    if (this.refs.form?.contains(event.target)) return;
    this.#hideResults();
  };

  #renderResults(matches) {
    if (!this.refs.list) return;
    this.refs.list.textContent = '';

    for (const entry of matches) {
      if (!entry.href) continue;

      const li = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'support-hub__result';
      link.href = /^https?:\/\//.test(entry.href)
        ? entry.href
        : window.Shopify.routes.root + entry.href.replace(/^\//, '');

      const category = document.createElement('span');
      category.className = 'support-hub__result-category';
      category.textContent = entry.category || '';

      const title = document.createElement('strong');
      title.textContent = entry.title || '';

      const description = document.createElement('span');
      description.textContent = entry.description || '';

      link.append(category, title, description);
      li.appendChild(link);
      this.refs.list.appendChild(li);
    }
  }

  #scoreEntry(entry, query) {
    const title = (entry.title || '').toLowerCase();
    const description = (entry.description || '').toLowerCase();
    const keywords = Array.isArray(entry.keywords) ? entry.keywords.join(' ').toLowerCase() : '';
    let score = 0;

    if (title.indexOf(query) === 0) {
      score += 7;
    } else if (title.indexOf(query) > -1) {
      score += 4;
    }

    if (keywords.indexOf(query) > -1) score += 3;
    if (description.indexOf(query) > -1) score += 1;

    return score;
  }

  #getMatches(query) {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) return [];

    return this.#entries
      .map((entry) => ({
        entry,
        score: this.#scoreEntry(entry, normalizedQuery),
      }))
      .filter((item) => item.score > 0)
      .sort((a, b) => b.score - a.score || (a.entry.title || '').localeCompare(b.entry.title || ''))
      .slice(0, 6)
      .map((item) => item.entry);
  }

  #setOpen(open) {
    if (this.refs.results) this.refs.results.hidden = !open;
    this.refs.input?.setAttribute('aria-expanded', String(open));
  }

  #hideResults() {
    this.#setOpen(false);
    if (this.refs.list) this.refs.list.textContent = '';
    if (this.refs.noResults) this.refs.noResults.hidden = true;
  }

  #showResults(query) {
    if (!query.trim()) {
      this.#hideResults();
      return;
    }

    const matches = this.#getMatches(query);
    this.#renderResults(matches);

    const hasResults = matches.length > 0;
    if (this.refs.noResults) this.refs.noResults.hidden = hasResults;
    if (this.refs.list) this.refs.list.hidden = !hasResults;
    this.#setOpen(true);
  }
}

if (!customElements.get('support-hub-component')) {
  customElements.define('support-hub-component', SupportHubComponent);
}

